import { Component, inject, Input } from '@angular/core';
import { ButtonDirective } from 'primeng/button';
import { Story } from '../../../models/story';
import { GlobalsStore } from '../../../stores/globals.state';

@Component({
  selector: 'app-story-button',
  standalone: true,
  imports: [ButtonDirective],
  templateUrl: './story-button.component.html',
  styleUrl: './story-button.component.scss',
})
export class StoryButtonComponent {
  readonly globalsStore = inject(GlobalsStore);
  @Input() story!: Story;

  public openStory() {
    this.globalsStore.triggerAtlasEvent('loadStory', {
      storyId: this.story._id,
    });
  }
}
